import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconArrowRightExtraBold = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#222',
    width = '100%',
    height = '100%',
    viewBox = '0 0 8 12',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    fillRule: "nonzero",
    d: "M5.95 0.611L6.869 1.53 2.469 5.93 6.869 10.33 5.95 11.249 0.631 5.93z",
    transform: "rotate(-180 4 6)"
  }))));
});

export { IconArrowRightExtraBold as default };
